import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import PickupProInfo from '../../Dispatch/RouteExecution/ProDetails/PickupProInfo';
import useUpdateOrRemoveQueryParams from '../../../../routes/utils/useUpdateOrRemoveQueryParams';
import Events from '../../../../utilities/EventEmitter';

const styles = (_theme) => ({
  proDetailsPanel: {
    position: 'absolute',
    left: 'auto',
    zIndex: 2001 //set more than, pickupInfoPopup
  },
  paperDrawer: {
    height: 'calc(100% - 54px)',
    marginTop: '49px',
    marginRight: '5px'
  }
});

/* Tech Dock: https://confluence.optym.net/pages/viewpage.action?pageId=326308802 */
const ShowPickupProDetailsPopup = (props) => {
  const location = useLocation();
  const proId = props.proId;
  const updateOrRemoveQueryParams = useUpdateOrRemoveQueryParams();

  useEffect(() => {
    if (location.state?.isResized) {
      Events.emit('ResizePickupInfo', { isResized: true });
    }
  }, [proId, location.state?.proDetails?.pickupShipmentId]);

  const handleClose = () => {
    updateOrRemoveQueryParams({
      paramsToUpdate: { proId: null, seq: null, isPickupPro: null },
      shouldRemove: true,
      stateData: location.state
    });
    Events.emit('ResizePickupInfo', { isResized: false });
  };

  return proId && location.state?.pickupInfo ? (
    <PickupProInfo
      open
      proDetails={location.state.proDetails}
      pickupInfo={location.state.pickupInfo}
      driverDetails={location.state.driverDetails}
      onClose={handleClose}
      customModalClasses={props.classes.proDetailsPanel}
      customDrawerPaperClasses={props.classes.paperDrawer}
      applyDrawerShadow
      proImageApiName={location.state.proImageApiName}
    />
  ) : null;
};

export default withStyles(styles)(ShowPickupProDetailsPopup);
